import { useCallback, useEffect, useRef } from 'react';
import { useFormMessageEvents } from './useFormMessageEvents';
import { useV3FormThemeCss } from './useV3FormThemeCss';
import { getFormsDomain, injectScript } from './formScript';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
export function VersionOneForm({
  formId,
  portalId,
  env,
  region,
  dispatch
}) {
  const containerId = useRef(
  // eslint-disable-next-line react-hooks/purity
  `hs-form-container-${formId}-${Math.random().toString(36).slice(2, 8)}`);
  const instanceRef = useRef(null);
  const readyPendingRef = useRef(false);
  const cancelledRef = useRef(false);
  useV3FormThemeCss(formId);
  const renderForm = useCallback(() => {
    const api = window.HubSpotForms;
    const result = api.create({
      portalId,
      formId,
      region,
      env,
      target: `#${containerId.current}`
    });
    Promise.resolve(result).then(instance => {
      if (cancelledRef.current) return;
      instance.version = 1;
      instanceRef.current = instance;
      if (readyPendingRef.current) {
        readyPendingRef.current = false;
        dispatch('onFormReady', instance);
      }
    }).catch(() => {
      // Failure surfaced through script error or postMessage onFormLoadError
    });
  }, [formId, portalId, env, region, dispatch]);
  const handleScriptError = useCallback(() => dispatch('onFormLoadError'), [dispatch]);
  useEffect(() => {
    cancelledRef.current = false;
    const currentContainerId = containerId.current;
    injectScript(`//js.${getFormsDomain(env)}/forms/embed/v3.js`, renderForm, handleScriptError);
    return () => {
      cancelledRef.current = true;
      const container = document.getElementById(currentContainerId);
      if (container) {
        container.innerHTML = '';
      }
      instanceRef.current = null;
      readyPendingRef.current = false;
    };
  }, [env, renderForm, handleScriptError]);
  const dispatchWithInstance = useCallback(eventName => {
    if (eventName !== 'onFormReady') {
      dispatch(eventName);
      return;
    }
    const instance = instanceRef.current;
    if (instance) {
      dispatch('onFormReady', instance);
    } else {
      readyPendingRef.current = true;
    }
  }, [dispatch]);
  useFormMessageEvents(formId, dispatchWithInstance);
  return /*#__PURE__*/_jsx(View, {
    paddingInline: "600",
    backgroundColor: "fill-surface-default"
    // eslint-disable-next-line react-hooks/refs
    ,
    id: containerId.current
  });
}